<template>
  <div>
    <template v-if="config.search_fields">
      <form @submit.prevent="search(true)">
        <div class="col-lg-12 offset-lg-0 search_box">
          <table class="table_search">
            <colgroup>
              <col style="width: 100px" />
            </colgroup>
            <template v-if="this.$root.guiPerm == 'ROOT'">
              <tr>
                <th
                style="
                  width: 100px;
                  font-weight: 100;
                  font-size:13px;
                  text-align:left;
                  border-top: 1px solid #ccc;
                  color:#000;
                "
                >
                  본부분류
                </th>
                <th style="border-top: 1px solid #ccc;">
                </th>
                <td
                  style="text-align: left; border-top: 1px solid #ccc"
                  colspan="3"
                >
                  <button
                    type="button"
                    class="btn btn-warning btn-sm"
                    style="width: 160px; margin: 2px; padding: 10px 0"
                    v-for="firstlist in firstlists"
                    v-bind:key="firstlist.id"
                    @click="
                      firstselected = firstlist.id;
                      viewSecond();
                    "
                  >
                    {{ firstlist.name }}
                  </button>
                </td>
              </tr>
            </template>
            <template
              v-if="
                this.$root.guiPerm == 'ROOT' || this.$root.guiPerm == 'LOCAL'
              "
            >
              <tr>
                <th
                style="
                  width: 100px;
                  font-weight: 100;
                  font-size:13px;
                  text-align:left;
                  border-top: 1px solid #ccc;
                  color:#000;
                "
                >
                  캠퍼스분류
                </th>
                <th style="border-top: 1px solid #ccc;">
                </th>
                <td style="text-align: left; border-top: 1px solid #ccc">
                  <select
                    v-model="subselected"
                    @change="viewclass()"
                    style="border: 1px solid #ccc; padding: 4px"
                  >
                    <option value>캠퍼스</option>
                    <option
                      v-for="sublist in sublists"
                      :value="sublist.id"
                      v-bind:key="sublist.id"
                    >
                      {{ sublist.name }}
                    </option>
                  </select>
                </td>
              </tr>
            </template>
            <tr>
              <th
              style="
                width: 100px;
                font-weight: 100;
                font-size:13px;
                text-align:left;
                border-top: 1px solid #ccc;
                color:#000;
              "
              >
                클래스분류
              </th>
              <th style="border-top: 1px solid #ccc;">
              </th>
              <td
                style="
                  width: 70px;
                  text-align: left;
                  border-top: 1px solid #ccc;
                "
              >
                <select
                  v-model="cate_filter_class"
                  @change="
                    viewClassStudent();
                    selectedSearchClass(this);
                  "
                  style="border: 1px solid #ccc; padding: 4px"
                >
                  <option value>클래스</option>
                  <option
                    v-for="classlist in subclasslists"
                    :value="classlist.id"
                    v-bind:key="classlist.id"
                  >
                    {{ classlist.name }}
                  </option>
                </select>
              </td>
              <th
                style="
                  width: 100px;
                  font-weight: 100;
                  border-top: 1px solid #ccc;
                "
              >
                학생분류
              </th>
              <td style="text-align: left; border-top: 1px solid #ccc">
                <select
                  v-model="cate_filter_student"
                  @change="selectedSearchstudent(this)"
                  style="border: 1px solid #ccc; padding: 4px"
                >
                  <option value>전체</option>
                  <option
                    v-for="studentlist in substudentlists"
                    :value="studentlist.id"
                    v-bind:key="studentlist.id"
                  >
                    {{ studentlist.name }}
                  </option>
                </select>
              </td>
            </tr>
            <tr
              v-for="(filter, i) in config.search_fields.filter((v) => !v.hide)"
              :key="i"
            >
              <th
              style="
                width: 100px;
                font-weight: 100;
                font-size:13px;
                text-align:left;
                border-top: 1px solid #ccc;
                color:#000;
              "
              >
                {{ filter.name
                }}
              </th>
              <th style="width:10px; padding:10px; border-top: 1px solid #ccc;">


              <button
                class="btn btn-success btn-sm" style="padding:0px; margin-left:6px; padding:1px 2px;"

                @click="clear_var(filter.id)"
              >
                <i class="bi bi-arrow-counterclockwise"></i>
              </button>
            </th>
              <td
                colspan="3"
                style="text-align: left; border-top: 1px solid #ccc"
              >
                <div
                  class="input-group mb-12"
                  v-if="
                    filter.type == 'date' ||
                    filter.type == 'time' ||
                    filter.type == 'datetime-local'
                  "
                >
                  <div class="input-group-prepend" style="color: #333">
                    <select
                      id="inputGroupSelect01"
                      v-model="filter_values[filter.id + '_type']"
                      style="
                        width: 120px;
                        display: inline;
                        border: 1px solid #ccc;
                        border-radius: 4px;
                        height: 38px;
                        padding: 3px;
                      "
                      v-if="filter.filter_type"
                    >
                      <option selected>선택</option>
                      <option
                        v-for="(value, key) in filter.filter_type"
                        :key="filter.id + key"
                        :value="key"
                      >
                        {{ value }}
                      </option></select
                    >&nbsp;
                    <input
                      :type="filter.type" id="date_filter_start"
                      v-model="filter_values[filter.id + '_start']"
                      style="
                        border: 1px solid #ccc;
                        border-radius: 4px;
                        height: 38px;
                        padding: 3px;
                      "
                    />
                    &nbsp;~&nbsp;
                    <input
                      :type="filter.type" id="date_filter_end"
                      v-model="filter_values[filter.id + '_end']"
                      style="
                        border: 1px solid #ccc;
                        border-radius: 4px;
                        height: 38px;
                        padding: 3px;
                      "
                    />
                  </div>
                </div>
                <div
                  class="input-group mb-12"
                  v-else-if="filter.type == 'month'"
                >
                  <div class="input-group-prepend" style="color: #333">
                    <input
                      type="month"
                      v-model="filter_values[filter.id]"
                      style="
                        border: 1px solid #ccc;
                        border-radius: 4px;
                        height: 38px;
                        padding: 3px;
                      "
                    />
                  </div>
                </div>
                <div
                  class="type_a"
                  v-else-if="filter.type == 'select'"
                  style="list-style-type: none"
                >
                
                  <div class="input-group-prepend" style="color: #333">
                    <select
                      id="inputGroupSelect02"
                      v-model="filter_values[filter.id + '_type']"
                      style="
                        width: 120px;
                        display: inline;
                        border: 1px solid #ccc;
                        border-radius: 4px;
                        height: 38px;
                        padding: 3px;
                      "
                      v-if="filter.filter_type"
                    >
                      <option
                        v-for="(value, key) in filter.filter_type"
                        :key="filter.id + key"
                        :value="key"
                      >
                        {{ value }}
                      </option></select
                    >
                    </div>
                </div>
                <ul
                  class="type_a"
                  v-else-if="filter.type == 'switch'"
                  style="list-style-type: none"
                >
                  <li
                    v-for="(value, key) in filter.filter_type"
                    :key="filter.id + key"
                    :style="value.css || {}"
                  >
                    <div
                      class="form-check form-switch"
                      style="margin-left: -30px"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="filter.id + '_' + key"
                        v-model="filter_values[filter.id + '_' + key]"
                        style="padding-left: 0"
                      />
                      <label
                        class="form-check-label"
                        :for="filter.id + '_' + key"
                        >{{ value.name || value }}</label
                      >
                    </div>
                  </li>
                </ul>
                
                <ul
                  class="type_a"
                  v-else-if="filter.type == 'range'"
                  style="list-style-type: none"
                >
                  <div v-for="i in 10" :key="i">
                    <template
                      v-if="
                        i == 1 ||
                        filter_values[filter.id + '_' + (i - 1) + '_operator']
                      "
                    >
                      {{ filter.value_name }}이(가)
                      <input
                        type="text"
                        class="input"
                        v-model="filter_values[filter.id + '_' + i]"
                      />

                      <select
                        v-model="
                          filter_values[filter.id + '_' + i + '_operator']
                        "
                      >
                        <option value="">[선택]</option>
                        <option value="same">와 같음</option>
                        <option value="notsame">와 같지 않음</option>
                        <option value="lt">보다 작음</option>
                        <option value="gt">보다 큼</option>
                        <option value="le">보다 작거나 같음</option>
                        <option value="ge">보다 크거나 같음</option>
                      </select>
                    </template>
                  </div>
                </ul>
                <span
                  class="type_a"
                  v-else-if="filter.type == 'range_preselect'"
                >
                  {{ filter.value_name }}
                  <select
                    v-model="filter_values[filter.id]"
                    style="
                      border: 1px solid #ccc;
                      border-radius: 4px;
                      padding: 2px;
                    "
                  >
                    <option value="">[선택]</option>
                    <option v-for="num in filter.filter_type" :key="num">
                      {{ num }}
                    </option>
                  </select>
                  이하
                </span>
                <div
                  class="input-group mb-12"
                  v-else-if="filter.type == 'custom'"
                >
                  <slot
                    :name="'search_' + filter.custom_name"
                    :filter="filter"
                    :callback="(answer) => (filter_values[filter.id] = answer)"
                  ></slot>
                </div>
                <div class="input-group mb-12" v-else>
                  <div class="input-group-prepend">
                    <input
                      type="text"
                      class="form-control-inline"
                      style="width: 440px"
                      v-model="filter_values[filter.id]"
                      :placeholder="filter.placeholder"
                    />
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </form>
    </template>

    <div class="col-lg-6 offset-lg-3">
      <div class="flex_center">
        <button
          class="btn btn-secondary"
          @click="search(true)"
          v-if="!config.no_search"
        >
          조회
        </button>
        <button
          class="btn btn-success"
          @click="getExcel()"
          v-if="!config.no_excel"
        >
          <i class="fas fa-file-excel" style="margin-right: 5px"></i>엑셀저장
        </button>
        <slot name="actions" :records="records" />
      </div>
    </div>
    <div style="margin: 10px">
      총 건수 : <span style="font-weight: bold">{{ total }}</span
      >건
    </div>
    <span style="font-size: 13px"
      >* 검색 기간이 길 경우 데이터 로딩이 오래 걸릴 수 있습니다.<br />
      * 검색 기간은 최대 3개월입니다.</span
    ><br />
    <slot name="resultactions" :records="records" :checked="checked" />
    <table class="table table-hover table-striped" style="margin: 4px 0">
      <thead>
        <tr style="height: 20px">
          <template v-for="col in config.columns" :key="col.id">
            <th scope="col" @click="sortAction(col.id)" v-if="col.sortable">
              {{ col.name }}
              <i
                class="bi"
                v-if="order_by == col.id"
                :class="{
                  'bi-caret-up-fill': order_reverse,
                  'bi-caret-down-fill': !order_reverse,
                }"
              ></i
              ><i class="fa-solid fa-list" v-else></i>
            </th>
            <th scope="col" v-else>
              <template v-if="col.is_check"
                ><input
                  type="checkbox"
                  @click.prevent="toggleAllChecks()"
                /> </template
              ><template v-else>{{ col.name }}</template>
            </th>
          </template>
        </tr>
      </thead>
      <tbody>
        <slot name="items" :records="records"></slot>
      </tbody>
    </table>
    <div style="display: flex; align-items: center; justify-content: center">
      <v-pagination
        v-model="page"
        :pages="Math.ceil(total / limit)"
        :range-size="3"
        active-color="#DCEDFF"
        @update:modelValue="
          (i) => {
            offset = (i - 1) * limit;
            search();
          }
        "
      /><select
        v-model="limit"
        @change="
          (i) => {
            offset = 0;
            page = 1;
            search();
          }
        "
        style="
          padding: 4px;
          font-size: 12px;
          border: 1px solid #ccc;
          margin-left: 10px;
        "
      >
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="500" disabled>500</option>
        <option value="1000" disabled>1000</option>
      </select>
    </div>
  </div>
</template>

<script>
import Tree from "../components/Tree";
import treeBtn from "../components/treeBtn";
import axios from "axios";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
export default {
  name: "QueryGrid",
  components: {
    VPagination,
    Tree,
    treeBtn,
  },
  props: {
    config: Object,
  },
  watch: {
    config() {
      this.filter_values = this.$parent.$route.query.qg_opt
        ? JSON.parse(this.$parent.$route.query.qg_opt)
        : {}; // wipe search when config changes
      this.records = [];
      this.total = 0;
    },
  },
  data: function () {
    return {
      isMounted: false,
      filter_values: {},
      firstlists: [],
      sublists: [],
      subclasslists: [],
      substudentlists: [],
      records: [],
      total: 0,
      offset: 0,
      order_reverse: false,
      order_by: "",
      subselected: "",
      cate_filter_class: "",
      cate_filter_student: "",
      limit: 20,
      page: 1,
    };
  },
  mounted() {
    if (this.$root.guiPerm == "ROOT") {
      axios.get("/admin/sub_categories").then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.firstlists = response.data.result;
          //console.log(this.firstlists);
        }
      });
    } else if (this.$root.guiPerm == "LOCAL") {
      axios
        .get("/admin/sub_categories/" + this.$root.guiPerm)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.sublists = response.data.result;
            //console.log(this.firstlists);
          }
        });
    } else if (
      this.$root.guiPerm == "ENTERPRISE" ||
      this.$root.guiPerm == "CLASS"
    ) {
      axios
        .get("/admin/class_categories/" + this.$root.guiPerm)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.subclasslists = response.data.result;
            this.search(true);
            //console.log(this.firstlists);
          }
        });
    }

    this.limit = this.config.default_limit ? this.config.default_limit : 20;
    if (!this.config.disable_init_search) this.search(true);
    this.isMounted = true;
    this.filter_values = this.$parent.$route.query.qg_opt
      ? JSON.parse(this.$parent.$route.query.qg_opt)
      : {}; // wipe search when config changes

    //datetime format "YYYY-MM-DD HH:mm:ss"
    var timezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
    var now = new Date(Date.now() - timezoneOffset); // 현재 날짜 및 시간
    var st_date = now.toISOString().substr(0, 10).replace("T", " ");
    var oneMonthAgo = new Date(now.setMonth(now.getMonth() - 1))
      .toISOString()
      .substr(0, 10)
      .replace("T", " "); // 한달 전
    var treeMonthAgo = new Date(now.setMonth(now.getMonth() - 2))
      .toISOString()
      .substr(0, 10)
      .replace("T", " "); // 세달 전
    //console.log(oneMonthAgo)

    this.filter_values["date_filter_type"] = "created_at";
    this.filter_values["section_filter_type"] = "default";

    this.filter_values["date_filter_start"] = oneMonthAgo;
    this.filter_values["date_filter_end"] = st_date;

    document.getElementById("date_filter_start").setAttribute("min", treeMonthAgo);
    document.getElementById("date_filter_end").setAttribute("min", treeMonthAgo);

    document.getElementById("date_filter_start").setAttribute("max", st_date);
    //document.getElementById("date_filter_end").setAttribute("max", st_date);


  },
  methods: {
    clear_var(filter_id) {
      Object.keys(this.filter_values).forEach((k) => {
        if (k.startsWith(filter_id)) {
          delete this.filter_values[k];
        }
      });
      if (this.$refs["search" + filter_id].length) {
        this.$refs["search" + filter_id][0].reset([]);
      }
    },
    toggleAllChecks() {
      var to = null;
      var status = this.getAllCheckStatus();
      if (status <= 0) {
        to = true;
      } else {
        to = false;
      }
      this.updateAllChecks(to);
    },
    updateAllChecks(status) {
      this.records.forEach((v) => {
        v.checked = !!status;
      });
    },
    getAllCheckStatus() {
      var checks = this.records.map((x) => x.checked || false);
      console.log(checks);
      if (!checks.includes(true)) {
        console.log(-1);
        return -1;
      } else if (!checks.includes(false)) {
        console.log(1);
        return 1;
      } else {
        console.log(0);
        return 0;
      }
    },
    sortAction(item_name) {
      if (this.order_by == item_name) {
        if (this.order_reverse) {
          this.order_by = "";
          this.order_reverse = false;
        } else {
          this.order_reverse = true;
        }
      } else {
        this.order_by = item_name;
        this.order_reverse = false;
      }
      this.search();
    },
    selectedSearchBiz(filter_id, biz) {
      console.log(biz);
      this.filter_values[filter_id] = biz;
      this.search(true);
    },
    selectedSearchClass(biz) {
      this.filter_values[this.cate_filter_class] = biz;
      this.search(true);
    },
    selectedSearchstudent(biz) {
      this.filter_values[this.cate_filter_student] = biz;
      this.search(true);
    },
    async getExtras(include_paging) {
      var extras = include_paging
        ? "?limit=" + this.limit + "&offset=" + this.offset
        : "?";
      if (this.cate_filter_class) {
        extras += "&cate_filter_class=" + this.cate_filter_class;
      }
      if (this.cate_filter_student) {
        extras += "&cate_filter_student=" + this.cate_filter_student;
      }
      if (this.subselected) {
        extras += "&subselected=" + this.subselected;
      }
      if (this.config.search_fields) {
        this.config.search_fields.forEach((filter) => {
          if (
            filter.type == "date" ||
            filter.type == "time" ||
            filter.type == "datetime-local"
          ) {
            if (this.filter_values[filter.id + "_type"])
              extras +=
                "&" +
                filter.id +
                "_type=" +
                this.filter_values[filter.id + "_type"];
            if (this.filter_values[filter.id + "_start"]) {
              extras +=
                "&" +
                filter.id +
                "_start=" +
                this.filter_values[filter.id + "_start"];
            }
            if (this.filter_values[filter.id + "_end"]) {
              extras +=
                "&" +
                filter.id +
                "_end=" +
                this.filter_values[filter.id + "_end"];
            }
          } else if (filter.type == "select") {
            if (this.filter_values[filter.id + "_type"])
              extras +=
                "&" +
                filter.id +
                "=" +
                this.filter_values[filter.id + "_type"];
          }else if (filter.type == "switch") {
            var f = [];
            Object.keys(filter.filter_type).forEach((k) => {
              if (this.filter_values[filter.id + "_" + k]) {
                f.push(k);
              }
            });
            if (f.length) {
              extras += "&" + filter.id + "=" + JSON.stringify(f);
            }
          } else if (filter.type == "range") {
            // WIP
            console.log(this.filter_values);
            for (let i = 1; i < 11; i++) {
              if (this.filter_values[filter.id + "_" + i + "_operator"]) {
                extras +=
                  "&" +
                  filter.id +
                  "_" +
                  i +
                  "_operator=" +
                  this.filter_values[filter.id + "_" + i + "_operator"] +
                  "&" +
                  filter.id +
                  "_" +
                  i +
                  "=" +
                  this.filter_values[filter.id + "_" + i];
              } else {
                break;
              }
            }
          } else {
            if (this.filter_values[filter.id])
              extras += "&" + filter.id + "=" + this.filter_values[filter.id];
          }
        });
      }

      if (this.order_by) {
        extras += "&order_by=" + this.order_by;
        if (this.order_reverse) {
          extras += "&order_reverse=y";
        }
      }

      if (this.config.extras_addon)
        extras += await this.config.extras_addon(
          this.filter_values,
          this.limit,
          this.offset
        );

      return extras;
    },
    async search(reset) {
      if (reset) {
        this.offset = 0;
        this.page = 1;
      }

      var extras = await this.getExtras(true);
      axios.get(this.config.req_endpoint + extras).then(async (response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          if (this.config.grid_parser) {
            var parse_result = await this.config.grid_parser(response.data);
            this.records = parse_result.records;
            this.total = parse_result.total;
          } else {
            this.records = response.data.result;
            this.total = response.data.total;
          }
        }
      });
    },
    async getExcel() {
      var extras = await this.getExtras(false);
      axios
        .get(this.config.req_endpoint + extras + "&limit=2147483647&offset=0")
        .then(async (response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            var csv =
              '<meta http-equiv="Content-Type" content="application/vnd.ms-excel; charset=UTF-8" /><head><style>td{mso-number-format: "@";}</style><body><table><tr>';
            this.config.columns.forEach((col) => {
              if (col.excel_print) {
                csv += "<th>" + col.name + "</th>";
              }
            });
            csv += "</tr>";
            var records = [];
            if (this.config.grid_parser) {
              var parse_result = await this.config.grid_parser(response.data);
              records = parse_result.records;
            } else {
              records = response.data.result;
            }

            records.forEach((data) => {
              csv += "<tr>";
              this.config.columns.forEach((col) => {
                if (col.excel_print) {
                  csv +=
                    "<td>" +
                    (col.excel_print(data) || "")
                      .toString()
                      .replaceAll("\n", "<br>") +
                    "</td>";
                }
              });
              csv += "</tr>";
            });
            csv += "</table></body>";
            var filename =
              this.config.name +
              " (" +
              new Date() +
              ") " +
              extras.replace("?&", "").replaceAll('"', "") +
              ".xls";
            const blob = new Blob([csv], { type: "text/xls" });
            const elem = window.document.createElement("a");
            elem.href = window.URL.createObjectURL(blob);
            elem.download = filename;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
          }
        });
    },
    pushSetting(config_name, value) {
      this.filter_values[config_name] = value;
    },
    viewSecond() {
      this.subselected = "";
      this.cate_filter_class = "";
      this.cate_filter_student = "";
      this.sublists = "";
      this.subclasslists = "";
      this.substudentlists = "";
      axios
        .get("/admin/sub_categories/" + this.firstselected)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.sublists = response.data.result;
          }
        });
    },
    viewclass() {
      this.cate_filter_class = "";
      this.cate_filter_student = "";
      this.subclasslists = "";
      this.substudentlists = "";
      if (this.subselected) {
        axios
          .get("/admin/class_categories/" + this.subselected)
          .then((response) => {
            if (response.data.error) {
              $.notify(
                {
                  // options
                  message:
                    "데이터를 조회할 수 없습니다. " + response.data.error,
                },
                {
                  // settings
                  type: "danger",
                  z_index: 9999,
                }
              );
            } else {
              this.subclasslists = response.data.result;
            }
          });
      }
    },
    viewClassStudent() {
      this.cate_filter_student = "";
      this.substudentlists = "";
      if (this.cate_filter_class) {
        axios
          .get("/admin/class_students/" + this.cate_filter_class)
          .then((response) => {
            if (response.data.error) {
              $.notify(
                {
                  // options
                  message:
                    "데이터를 조회할 수 없습니다. " + response.data.error,
                },
                {
                  // settings
                  type: "danger",
                  z_index: 9999,
                }
              );
            } else {
              this.substudentlists = response.data.result;
              this.cate_filter_student = "";
            }
          });
      }
    },
  },
  computed: {
    checked: function () {
      return this.records.filter((record) => record.checked);
    },
  },
};
</script>

<style></style>
